import request from '@/utils/request'

export function getWechatCode (params) {
  return request({
    method: 'get',
    params: {
      do: 'getWechatCode',
      ...params
    }
  })
}
